export const CHECK_IN_PAGE_SIZES = [25, 50, 100];

export function paginateAdmissionRows(rows = [], page = 1, pageSize = 25) {
  const size = CHECK_IN_PAGE_SIZES.includes(Number(pageSize)) ? Number(pageSize) : 25;
  const pageCount = Math.max(1, Math.ceil(rows.length / size));
  const currentPage = Math.min(pageCount, Math.max(1, Number(page) || 1));
  const startIndex = (currentPage - 1) * size;
  return {
    currentPage,
    pageCount,
    startIndex,
    endIndex: Math.min(rows.length, startIndex + size),
    rows: rows.slice(startIndex, startIndex + size),
  };
}

export function admissionActionConfirmation(action, attendeeLabel = 'this attendee') {
  const label = String(attendeeLabel || 'this attendee').trim() || 'this attendee';
  if (action === 'check_in') return `Manually check in ${label}?`;
  if (action === 'undo') return `Undo the check-in for ${label}?`;
  if (action === 'void') return `Void the admission pass for ${label}? This does not refund their booking and the pass will stop working immediately.`;
  if (action === 'reissue') return `Reissue the admission pass for ${label}? Their previous QR code and manual code will stop working immediately.`;
  return '';
}
